import FormAlert from "./FormAlert";
import { useState } from "react";
import { Link } from "react-router";
import { useIsAdmin } from "@/api/hooks";
import AdminUserTable from "./AdminUserTable";

/**
 * User administration.
 *
 * A route rather than a Sheet, unlike UserSettingsSheet: the table does not
 * fit a 380px panel, and "admin" is already reserved server-side
 * (hg/constants.py RESERVED_NICKNAMES), so unlike a "/settings" route this
 * URL never costs anyone a nickname.
 */
export default function AdminPage() {
  const isAdmin = useIsAdmin();
  const [status, setStatus] = useState<string | null>(null);

  if (!isAdmin) {
    // Correct at mount: main.tsx awaits checkAuthorization before the
    // router renders, so `me` (and is_admin) is already populated. The real
    // enforcement is server-side -- every /admin/* request re-checks
    // is_admin itself.
    return (
      <div className="w-full h-full flex flex-col items-center justify-center gap-2 text-center p-4">
        <p className="text-muted-foreground">
          You do not have access to this page.
        </p>
        <Link to="/" className="text-sm underline underline-offset-4">
          Go back
        </Link>
      </div>
    );
  }

  return (
    <div className="w-full h-full overflow-y-auto p-4 flex flex-col gap-4">
      <FormAlert error={status} />
      <AdminUserTable onError={setStatus} />
    </div>
  );
}
